import { createAxios } from "./axiosHttpMarconi";

export const tarifaPaletsService = {
  getTarifasPalets,
  deleteTarifaPalet,
  postTarifaPalet,
  updateTarifaPalet,
  getTarifaPaletById,
};

function getTarifasPalets(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-palets`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  urlPath += getUrlPath(filters);
  return axios.get(urlPath);
}

function getUrlPath(filters) {
  let urlPath = "";
  if (filters && filters.franquicia) {
    urlPath += `&franquicia=${filters.franquicia}`;
  }
  return urlPath;
}

function deleteTarifaPalet(tarifaId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-palets/${tarifaId}`;
  return axios.delete(urlPath);
}

function postTarifaPalet(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-palets`;
  return axios.post(urlPath, request);
}

function updateTarifaPalet(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-palets/${id}`;
  return axios.put(urlPath, body);
}

function getTarifaPaletById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-palets/${id}`;
  return axios.get(urlPath);
}
